module.exports = __webpack_public_path__ + "static/media/resume.cb2489c9.pdf";